<router-outlet></router-outlet>
<iq-central-front-end-app-alert></iq-central-front-end-app-alert>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>

<app-chat></app-chat>